import $ from 'jquery';

import smoothScroll from './smooth-scroll';

$( document ).ready( function() {
	$( '#chrome-notice' ).click( function() {
		$( this ).slideToggle();
	} );

	$( '.offcanvas-toggle' ).click( function( e ) {
		e.preventDefault();
		$( 'header,body' ).toggleClass( 'offcanvas-open' );
	} );

	$( '.acf-index .list-header' ).click( function( e ) {
		e.preventDefault();
		$( this ).parent().toggleClass( 'minimal' );
	} );

	$( '.more .toggle' ).on( 'click', function() {
		$( this ).parent().toggleClass( 'open' );
		$( this ).parent().find( '.more-content' ).slideToggle();
	} );

	$( '.acf-faqs .question span' ).on( 'click', function( evt ) {
		evt.preventDefault();
		$( this ).parent().toggleClass( 'open' );
		$( this ).parent().next( '.answer' ).slideToggle();
	} );

	$( '.acf-number .num' ).rCounter( {
		duration: 30,
	} );

	if ( 'undefined' !== typeof $.fn.mediaelementplayer ) {
		$( 'video' ).mediaelementplayer( {

			// When using jQuery's `mediaelementplayer`, an `instance` argument
			// Is available in the `success` callback
			stretching: 'fill',
			alwaysShowControls: true,
			pauseOtherPlayers: false,
			success: ( mediaElement ) => {
				// Do things
				mediaElement.play();
				mediaElement.setMuted( true );
			},
		} );
	}

	// Scrollto
	function scrollHash( speed ) {
		let elemId = location.hash;
		elemId = elemId.split( '%20' ).join( '-' );
		elemId = elemId.split( ' ' ).join( '-' );

		const elem = document.getElementById( elemId.toLowerCase().replace( /^#/, '' ) );
		if ( elem ) {
			smoothScroll( $( elem ).offset().top - ( $( '#site-header' ).height() + 40 ), speed );
		}
	}

	$( document ).on( 'click', 'a', function( evt ) {
		const href = $( this ).attr( 'href' );

		if ( ! href ) {
			return;
		}

		if ( $( this ).hasClass( 'no-hashscroll' ) ) {
			return;
		}

		if ( 0 === href.indexOf( '#' ) ) {
			evt.preventDefault();
			history.pushState( {}, '', this.href );
			scrollHash( 500 );
		}
	} );

	// Scrollto fix on pageload with anchor
	if ( '' !== location.hash ) {
		scrollHash( 1000 );
	}

	$( '.scrollhint' ).click( function() {
		let scrollto = 0;

		if ( $( this ).hasClass( 'fixed' ) ) {
			scrollto = $( document ).scrollTop() + $( window ).height() - ( $( '#site-header' ).height() + 40 );
			if ( $( this ).hasClass( 'back' ) ) {
				scrollto = 0;
				$( this ).removeClass( 'back' );
			}

			smoothScroll( scrollto, 1000 );
		} else {
			smoothScroll( $( '#module-container' ).offset().top - ( $( '#site-header' ).height() + 40 ), 1000 );
		}
	} );

	$( 'form.newsletter a.button' ).on( 'click', function() {
		$( this ).closest( 'form' ).submit();
	} );

	$( 'form.newsletter' ).on( 'submit', function( evt ) {
		const form = $( this );

		evt.preventDefault();

		$.ajax( {
			type: 'POST',
			url: $( this ).attr( 'action' ),
			data: $( this ).serialize(),
			dataType: 'json',
		} ).done( function( resp ) {
			if ( resp.success ) {
				form.find( 'input[type=email]' ).val( '' );
				form.find( '.error' ).hide();
				form.find( '.success' ).show().text( resp.data );
			} else {
				form.find( '.error' ).show().text( resp.data );
				form.find( '.success' ).hide();
			}
		} );
	} );

	function spyscroll() {
		const scrollTop = $( this ).scrollTop();
		$( '#module-container' ).each( function() {
			const topDistance = $( this ).offset().top;
			if ( topDistance - 100 <= scrollTop ) {
				$( '.fix-me' ).addClass( 'fixed' );
				$( '#conversion' ).show().removeClass( 'slideOutLeft' ).addClass( 'slideInLeft' );
			} else {
				$( '.fix-me' ).removeClass( 'fixed' );
				$( '#conversion' ).removeClass( 'slideInLeft' ).addClass( 'slideOutLeft' );
			}
		} );

		if ( scrollTop + $( window ).height() + 50 >= $( document ).height() ) {
			$( '.fix-me' ).addClass( 'back' );
		} else {
			$( '.fix-me' ).removeClass( 'back' );
		}
	}

	spyscroll();
	window.addEventListener( 'scroll', spyscroll );
} );
